export default __webpack_public_path__ + "static/media/day-5.97a882a0.jpg";